import React from 'react';
import PropTypes from 'prop-types';

/**
 * ContentHeader Atom - nagłówek sekcji z opcjonalnym przyciskiem akcji
 */
const ContentHeader = ({ 
  title, 
  description, 
  primaryAction, 
  onPrimaryAction,
  className = '',
  ...props 
}) => {
  return (
    <div 
      className={`sm:flex sm:items-center pt-8 pb-6 ${className}`}
      {...props}
    >
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-2xl font-medium leading-6 text-neutral-900">
              {title}
            </h1>
            {description && (
              <p className="mt-4 text-base text-neutral-600 max-w-4xl leading-6">
                {description}
              </p>
            )}
          </div>
          {primaryAction && onPrimaryAction && (
            <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
              <button
                type="button"
                onClick={onPrimaryAction}
                className="btn btn-primary btn-md"
              >
                {primaryAction}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ContentHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  primaryAction: PropTypes.string,
  onPrimaryAction: PropTypes.func,
  className: PropTypes.string,
};

export default ContentHeader;